<template>
  <div class="home">
    このページはics.mediaの記事『
    <a href="https://ics.media/entry/200716/">
      エラーは出ないけど…何か変？？Vue.jsでやりがちな「サイレント・ミス」（ロジック編）
    </a>
    』のデモコードです。記事と合わせてご覧ください。
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {}
}
</script>
